var map = {
	"./dashboard/_index.js": "0MYX",
	"./data-input/_index.js": "yN7I",
	"./high-risk/_index.js": "h7pT",
	"./operational-unit/_index.js": "uuT6",
	"./private-qhse/_index.js": "Yuls",
	"./setup-single-number/_index.js": "2m7d",
	"./single-number/_index.js": "Uzxl",
	"./user-role/_index.js": "/wLf"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "wGqA";


//////////////////
// WEBPACK FOOTER
// ./src/modules _index\.js$
// module id = wGqA
// module chunks = 120